import React from 'react';
import PropTypes from 'prop-types';
import FeatureFlags from '../../../util/featureFlags';

const key = '&key=AIzaSyCDwNfhoUcGxdi5180ovBIAqrbDHmKotJ8';

const getCoordinates = marker => {
  const { position: pos } = marker;
  return pos.lat && pos.lng ? `${pos.lat},${pos.lng}` : '';
};

const formatMarkers = (markers, pin) =>
  markers.reduce((acc, marker, i) => {
    const icon = pin ? `icon:${encodeURI(pin)}%7C` : '';
    const position = getCoordinates(marker);
    return i === 0 ? `${acc}${icon}${position}%7C` : `${acc}${position}%7C`;
  }, 'markers=');

const flattenStyle = stylers =>
  stylers.reduce((acc, style) => {
    const keys = Object.keys(style);
    const rule = keys[0];
    const ruleArg = style[rule].toString().replace('#', '0x');
    return `${acc}${rule}:${ruleArg}%7C`;
  }, '');

const convertRuleToString = rule => {
  const keys = Object.keys(rule);
  let string = '';
  // add featureType
  if (keys.indexOf('featureType') > -1) string += `feature:${rule.featureType}%7C`;
  // add elementType
  if (keys.indexOf('elementType') > -1) string += `element:${rule.elementType}%7C`;
  // flatten style and add
  if (keys.indexOf('stylers') > -1) string += flattenStyle(rule.stylers);
  return string;
};

const formatStyle = style => {
  const styleArr = JSON.parse(style, 2, 2);
  return styleArr.length > 0
    ? styleArr.reduce((acc, rule) => {
        return `${acc}&style=${convertRuleToString(rule)}`;
      }, '')
    : '';
};

/* ———————————————————————————————————————— */

const StaticMap = ({ markers, theme }) => {
  const { pin, styles } = theme;
  const protocol = FeatureFlags.getEnvironment() === 'development' ? 'http' : 'https';
  const styleSegment = formatStyle(styles);
  const markerSegment = markers && markers.length > 0 ? formatMarkers(markers, pin) : null;
  const src = `${protocol}://maps.googleapis.com/maps/api/staticmap?size=640x320&scale=2&${markerSegment}${styleSegment}${key}`;
  const singleMarker = markers.length === 1;
  const href = `${protocol}://www.google.com/maps/search/?api=1&query=${getCoordinates(
    markers[0]
  )}`;

  return singleMarker ? (
    <a href={href} target="_blank" rel="noreferrer noopener">
      <img src={src} alt="place map" className="poi-map poi-map-img" />;
    </a>
  ) : (
    <img src={src} alt="place map" className="poi-map poi-map-img" />
  );
};

StaticMap.propTypes = {
  markers: PropTypes.arrayOf(PropTypes.shape({ position: {}, title: PropTypes.string })).isRequired,
  theme: PropTypes.shape({ styles: PropTypes.string, pin: PropTypes.string }),
};

export default StaticMap;



// WEBPACK FOOTER //
// ./src/components/common/ui/StaticMap.jsx